import React, { Component, PropTypes } from 'react';
import EditMeta from 'profile/containers/edit_meta';
import EditSocial from 'profile/components/edit_social';
import EditSpecializations from 'profile/containers/edit_specializations';
import Testimonials from 'profile/containers/testimonials';
import AllStats from 'profile/containers/all_stats';
import LanguageField from 'profile/containers/language_field';
import EditBackground from 'profile/containers/edit_background';

import { Field } from 'redux-form';
import { BasicTextAreaField } from 'common/components/form_fields';
import { LoadingIndicator } from 'common/components/preloader';
import { PROFILE_FORM } from 'profile/constants';


export default class EditProfile extends Component {

  componentDidMount() {
    const { isEditingOwn, goToProfile, fetchSpecializations } = this.props;
    if (!isEditingOwn) {
      return goToProfile();
    }
    return fetchSpecializations();
  }

  render() {
    const { handleSubmit, isLoading, anyTouched, aboutHiddenReason } = this.props;

    if (isLoading) {
      return <LoadingIndicator />;
    }

    return (
      <div id="content" className="profile-content edit-profile">
        <form onSubmit={handleSubmit}>
          <Field component={EditBackground} name="profile_bg" />
          <div className="row">
            <div className="small-16 medium-4 column">
              <EditMeta />
              <EditSpecializations formTouched={anyTouched}/>
              <div className="profile-languages">
                <h4>Speaks</h4>
                <Field component={LanguageField} formName={PROFILE_FORM} name="primary_lang" />
                <Field component={LanguageField} formName={PROFILE_FORM} name="additional_lang_1" />
              </div>
              <EditSocial />
            </div>
            <div className="small-16 medium-12 column">
              <AllStats />
              <Testimonials />
              <div className="profile-about">
                <h3>About</h3>
                <Field name="about" component={BasicTextAreaField} minRows="8"
                  description={aboutHiddenReason} />
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

EditProfile.propTypes = {
  isEditingOwn: PropTypes.bool,
  goToProfile: PropTypes.func,
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  fetchSpecializations: PropTypes.func,
  anyTouched: PropTypes.bool,
  aboutHiddenReason: PropTypes.string,
};



// WEBPACK FOOTER //
// ./profile/components/edit.jsx